import type { createWorkspaceFile } from './file';
import { defineRelations } from '@rstore/vue';
import { Collection } from '~/rstore/schema/workspace/schema/collection';
import { Block } from './block';
import { KeyStorage } from './key-storage';
import { Page, PageSection, Space } from './spaces';

// Space relations
export const SpaceRelations = defineRelations(Space, ({ collection }) => ({
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.spaceId': 'MonospaceSpace.id',
			},
		}),
	},
	pages: {
		to: collection(Page, {
			on: {
				'MonospacePage.spaceId': 'MonospaceSpace.id',
			},
		}),
		many: true,
	},
	sections: {
		to: collection(PageSection, {
			on: {
				'MonospacePageSection.spaceId': 'MonospaceSpace.id',
			},
		}),
		many: true,
	},
}));

export const PageRelations = defineRelations(Page, ({ collection }) => ({
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.pageId': 'MonospacePage.id',
			},
		}),
	},
	space: {
		to: collection(Space, {
			on: {
				'MonospaceSpace.id': 'MonospacePage.spaceId',
			},
		}),
	},
	section: {
		to: collection(PageSection, {
			on: {
				'MonospacePageSection.id': 'MonospacePage.sectionId',
			},
		}),
	},
	collection: {
		to: collection(Collection, {
			on: {
				'MonospaceCollection.id': 'MonospacePage.collectionId',
			},
		}),
	},
}));

export const PageSectionRelations = defineRelations(PageSection, ({ collection }) => ({
	pages: {
		to: collection(Page, {
			on: {
				'MonospacePage.sectionId': 'MonospacePageSection.id',
			},
		}),
		many: true,
	},
	space: {
		to: collection(Space, {
			on: {
				'MonospaceSpace.id': 'MonospacePageSection.spaceId',
			},
		}),
	},
}));

// KeyStorage relations
export const KeyStorageRelations = defineRelations(KeyStorage, ({ collection }) => ({
	collection: {
		to: collection(Collection, {
			on: {
				'MonospaceCollection.id': 'MonospaceKeyStorage.collectionId',
			},
		}),
	},
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.id': 'MonospaceKeyStorage.blockId',
			},
		}),
	},
}));

// File relations
export function createFileRelations(file: ReturnType<typeof createWorkspaceFile>) {
	return defineRelations(file, ({ collection }) => ({
		$thumbnail: {
			to: collection(file, {
				on: {
					'MonospaceFile.id': 'MonospaceFile.id',
				},
			}),
		},
	}));
}
